module.exports = __webpack_public_path__ + "static/media/England.0e6b6188.png";